import { format } from '@teetsh/app/src/utils/time/format';
import addMinutes from 'utils/time/addMinutes';
import { Reunion } from 'types/reunions';
import { UserLocale } from 'types/user';

/**
 * allDay : "Journée entière"
 * start : 15;05
 * start - end : 15h05 - 15h35
 * start - duration : 15h05 - 30min
 */

export function buildPlannerEventHours(
  reunion: Omit<Reunion, 'categoryId' | 'attachments'>,
  locale: UserLocale,
  allDayTitle: string,
  template: 'start - end' | 'start - duration' | 'start',
): string {
  const allDayEvent = reunion.lastingInMinutes === -1;
  if (allDayEvent) {
    return allDayTitle;
  }
  switch (template) {
    case 'start':
      return format(reunion.date, locale, "HH'h'mm");
    case 'start - end':
      return `${format(reunion.date, locale, "HH'h'mm")} - ${format(
        addMinutes(reunion.date, reunion.lastingInMinutes),
        locale,
        "HH'h'mm",
      )}`;
    case 'start - duration':
      return `${format(reunion.date, locale, "HH'h'mm")} - ${
        reunion.lastingInMinutes
      }min`;
  }
}
